import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { authSession } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { Flame } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) { navigate('/admin', { replace: true }); return; }
      try {
        const data = await authSession(sessionId);
        if (data.session_token) localStorage.setItem('zs_token', data.session_token);
        setUser(data.user);
        const dest = localStorage.getItem('zs_post_login') || (data.user?.is_admin ? '/admin/dashboard' : '/');
        localStorage.removeItem('zs_post_login');
        window.history.replaceState({}, document.title, dest);
        navigate(dest, { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate('/', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0a0a0a] text-white">
      <Flame className="w-10 h-10 text-orange-500 animate-pulse" />
      <p className="mt-4 text-white/60 uppercase tracking-widest text-sm">Signing you in…</p>
    </div>
  );
}
